import React from "react";

import { CROP_TYPE_FCPO, CropFCPO } from "models";

import { AdminDescriptions, Col, ErrorBoundary, Flex, Row, SkeletonWrapper, TagNormal, Typography } from "components";

export const CropsOverviewTable = ({
  isLoadingCropsData,
  cropsData,
  startYear,
  endYear,
}: {
  isLoadingCropsData: boolean;
  cropsData: CropFCPO[] | undefined;
  startYear: number;
  endYear: number;
}) => {
  if (!cropsData) return null;

  const mainTag = <TagNormal text="MAIN" color="green" style={{ transform: "translate(0, 0)", fontWeight: "bold" }} />;
  const sideTag = <TagNormal text="SIDE" color="red" style={{ transform: "translate(0, 0)", fontWeight: "bold" }} />;

  const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);

  const items = years.map((year) => ({
    label: year,
    children: (
      <Flex align="center" gap="middle">
        {cropsData
          .filter((crop) => crop.year === year)
          .sort((a, b) => (b.cropType === CROP_TYPE_FCPO.MAIN ? 1 : 0) - (a.cropType === CROP_TYPE_FCPO.MAIN ? 1 : 0))
          .map((crop) => (
            <Flex key={crop.cropId} align="center" gap="small">
              <Typography variant="paragraph-m">{crop.cropName}</Typography>
              {crop.cropType === CROP_TYPE_FCPO.MAIN ? mainTag : sideTag}
            </Flex>
          ))}
      </Flex>
    ),
  }));

  return (
    <>
      <SkeletonWrapper isLoading={isLoadingCropsData}>
        <ErrorBoundary>
          <Row>
            <Col span={24}>
              <AdminDescriptions items={items} columns={1} />
            </Col>
          </Row>
        </ErrorBoundary>
      </SkeletonWrapper>
    </>
  );
};
